import { getStore } from '../../store';
import { setTokenState } from 'app/auth/store/refreshTokenSlice';
import { AuthService } from '..';

// refresh token state
const tokenState = getStore()?.getState()?.auth?.refreshToken;

// TODO: burada OIDC renew token erroru mu diye kontrol et!!!!!

const isRenewRequest = config => config.url === 'auth/refresh';
const isRenewTokenError = error => isRenewRequest(error.config);

const setNewToken = (request, token) => {
  request.headers['x-access-token'] =
    token || tokenState?.newToken || getStore().getState()?.auth?.login?.token;
};

const waitTillRenewToken = () =>
  new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const tokenState = getStore().getState().auth.tokenState;
      if (tokenState.received || tokenState.error) clearInterval(interval);

      if (tokenState.received) {
        resolve();
      } else if (tokenState.error) {
        reject(tokenState.error);
      }
    }, 1000);
  });

export const onRequest = async config => {
  // if token is requested, hold request
  if (tokenState.requested) await waitTillRenewToken();
};

// TODO: - 401 burada hallet

// will handle authentication error
// there can be two types of authentication error
// 1. comes from renew
// 2. comes from other requests
export const handleAuthError = (axios, error) => {
  const originalRequest = error.config;

  if (isRenewTokenError(error)) {
    // if this is a renew token error
    // we just logout the user
    // AuthManager.logout();
    AuthService.logout();
    return Promise.reject(error);
  }

  // check if this request has been tried before
  // if its we' ll reject directly
  if (!originalRequest.retry) {
    originalRequest.retry = true;

    // if not, check if another request
    // tried to renew token
    if (!tokenState.requested) {
      // tokenState.newToken = null;
      getStore().dispatch(setTokenState({ newToken: null }));

      return AuthService.renewToken().then(
        accessToken => {
          // tokenState.newToken = accessToken;
          getStore().dispatch(setTokenState({ newToken: accessToken }));

          setNewToken(originalRequest, accessToken);
          getStore().dispatch(setTokenState({ requested: false, received: true }));

          return axios(originalRequest);
        },
        refreshTokenError => {
          getStore().dispatch(
            setTokenState({ requested: false, received: false, error: refreshTokenError })
          );

          return Promise.reject(refreshTokenError);
        }
      );
    }
    // if token is already requested
    // hold this request until we get new token

    return waitTillRenewToken().then(
      () => {
        setNewToken(originalRequest);
        return axios(originalRequest);
      },
      refreshTokenError => Promise.reject(refreshTokenError)
    );
  }

  return Promise.reject(error);
};
